function StickyOffset() {
  const updateStickyOffset = () => {
    const stuckElements = document.querySelectorAll("[data-stuck]");
    let totalHeight = 0;

    stuckElements.forEach((el) => {
      const rect = el.getBoundingClientRect();
      totalHeight += rect.height;
    });

    document.documentElement.style.setProperty(
      "--sticky-offset",
      `${totalHeight}px`,
    );
  };

  const observer = new MutationObserver((mutations) => {
    let shouldUpdate = false;

    mutations.forEach((mutation) => {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "data-stuck"
      ) {
        shouldUpdate = true;
      }
      if (mutation.type === "childList") {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.matches("[data-stuck]")) {
            observer.observe(node, { attributes: true });
            shouldUpdate = true;
          }
        });
      }
    });

    if (shouldUpdate) updateStickyOffset();
  });

  observer.observe(document.body, {
    attributes: true,
    childList: true,
    subtree: true,
  });

  updateStickyOffset();

  window.addEventListener("resize", updateStickyOffset);

  window.addEventListener("scroll", updateStickyOffset);
}

export default StickyOffset;
